import type { StudioClient } from "../../schema";

export const studioClients: StudioClient[] = [
  // {
  //   name: "Aeterna",
  //   subtitle: "Business platform",
  //   coverImg: "/images/studio/clients/Aeterna1.png",
  //   imgSrcs: ["/images/studio/clients/Aeterna1.png", "/images/studio/clients/Aeterna2.png"],
  //   desc: "We designed the complete UI/UX for Aterna, one of Egypt’s largest and most luxurious Nile cruise experiences. From immersive storytelling through visuals and micro-interactions to a refined design system that captures the essence of modern luxury and Egyptian heritage.",
  //   brief:
  //     "The project features a multi-language platform tailored for both local and international travelers, offering a smooth and intuitive booking system that simplifies reservations, trip customization, and experience selection. Beyond the website, we’ve built a digital experience that mirrors Aterna’s elegance.",
  //   servicesProvided: ["Social media", "Development", "Branding", "UI/UX"],
  // },
  {
    name: "VEROlabs",
    subtitle: "Education and VR",
    coverImg: "/images/studio/clients/vero.webp",
    imgSrcs: [
      "/images/studio/clients/vero1.webp",
      "/images/studio/clients/vero2.webp",
      "/images/studio/clients/vero3.webp",
    ],
    desc: "VEROlabs, a visionary project by VERO, is redefining how university students engage with science through virtual reality learning environments.",

    brief:
      "Built a complete brand identity and visual language that reflects innovation, exploration, and learning. Our team designed the UI/UX for immersive VR lab simulations, as well as the student and instructor portals and the CMS that enables smooth lab updates and performance tracking. The result is a modern, scalable platform that turns traditional lab work into interactive digital experiences.",
    servicesProvided: ["Branding", "UI/UX"],
  },
  {
    name: "DietHub",
    subtitle: "Health and overall wellness",
    coverImg: "/images/studio/clients/Diethub.webp",
    imgSrcs: [
      "/images/studio/clients/diet1.webp",
      "/images/studio/clients/diet2.webp",
      "/images/studio/clients/diet3.webp",
      "/images/studio/clients/diet4.webp",
      "/images/studio/clients/diet5.webp",
    ],
    desc: "Designed and developed DietHub's platform, a dynamic digital platform that connects nutrition, technology, and lifestyle.",

    brief:
      "The website was fully integrated with Bitrix24 and Odoo to streamline client management, operations, and order tracking. We built a custom CMS and an advanced analytics module, combining Clarity and Google Analytics for deep insights into media and campaign performance. Every interaction — from browsing meal plans to tracking progress — is intuitive, engaging, and user-focused.",
    servicesProvided: ["Development", "UI/UX"],
  },
];
